import DOMAIN_PREFIX from "./domainPrefix.js"
const API_PREFIX = DOMAIN_PREFIX.API_PREFIX
const CAMERA_PREFIX = DOMAIN_PREFIX.CAMERA_PREFIX

const API = {
	header: {
		"Content-Type": "application/x-www-form-urlencoded",
	},

	// Camera
	startShow: CAMERA_PREFIX + "/startShow",
	remoteControl: CAMERA_PREFIX + "/remoteControl",
	findAllFile: CAMERA_PREFIX + "/findAllFile",
	download: CAMERA_PREFIX + "/download",

	getSampleProduct:API_PREFIX + "/product/getSampleProduct",
	getSampleVariableList:API_PREFIX +"/variable/getSampleVariableList",
	// Company
	getpromoteUserId:API_PREFIX + "/company/getpromoteUserId",   //推广码
	getCompanyApplyList:API_PREFIX + "/company/getCompanyApplyList",//注册的公司
	getCompanyInfoById: API_PREFIX + "/company/getCompanyInfoById",
	getCompanyList: API_PREFIX + "/company/getCompanyList",   //管理的公司
	getAllDeveloperOfCompany: API_PREFIX + "/company/getCompanyUserList",  //获取公司里面所有的成员的列表
	removeUserFromCompany: API_PREFIX + "/company/deleteCompanyUser",      //刪除公司用戶
	getAllProjectOfCompany: API_PREFIX + "/project/getProjectList",       //获取公司项目列表
	getStartJson: API_PREFIX + "/company/getStartJson",                   //获取主界面json    
	insertCompanyUser: API_PREFIX + "/company/insertCompanyUser",         //添加公司用户
	getUserCompanyList: API_PREFIX + "/company/getUserCompanyList",        //获取用户关联公司列表
    updateUserUploadImg: API_PREFIX + "/company/updateUserUploadImg",      //修改图片
    getUserUploadImgList: API_PREFIX + "/company/getUserUploadImgList",    //获取自定义图库
	deleteUserUploadImg: API_PREFIX + "/company/deleteUserUploadImg",      //删除自定义图库
    updateCompanyUser: API_PREFIX + "/company/updateCompanyUser",          //修改公司成员身份
	getUserPromoteList: API_PREFIX + "/user/getUserPromoteList",  //获取推广公司列表
	getUserWithdrawlList: API_PREFIX + "/user/getUserWithdrawlList",  //获取提现列表
	userWithdrawlApply: API_PREFIX + "/user/userWithdrawlApply",  //用户提现申请
	getBuyInfo: API_PREFIX + "/finance/getBuyInfo",                  //获取购买信息
	getTransactionRecords: API_PREFIX + "/finance/getTransactionRecords",    //获取购买订单
	applyCompanyUser: API_PREFIX + "/company/applyCompanyUser",    //用户处理公司邀请

	// Project
	addProjectForCompany: API_PREFIX + "/project/addProject",   //新增项目
	updateProject: API_PREFIX +"/project/updateProject",  //修改项目信息
	removeProjectFromCompany: API_PREFIX +"/project/deleteProject", //删除公司项目
	publishProject:API_PREFIX + "/project/publishProject",          //发布项目


	//product
	getProductList: API_PREFIX + "/product/getProductList",        //获取项目下的所有页面    
	getProductTemplateList: API_PREFIX +"/product/getProductTemplateList", //获取模板列表
	addProduct: API_PREFIX + "/product/addProduct",                        //新增页面
	deleteProduct: API_PREFIX + "/product/deleteProduct",                  //删除草稿
	publishProduct: API_PREFIX + "/product/publishProduct",                //发布页面
	getProductPublishedList: API_PREFIX + "/product/getProductPublishedList",    //发布页面列表
	updateProduct: API_PREFIX + "/product/updateProduct",                        //修改页面的名字和描述
	getProductUserList: API_PREFIX + "/product/getProductUserList",              //获取拥有页面权限的用户
	insertProductUser: API_PREFIX +"/product/insertProductUser",                 //页面授权，给用户授予不同的页面权限
	deleteProductUser: API_PREFIX + "/product/deleteProductUser",                //删除页面用户关系
	addMainPage: API_PREFIX + "/product/addMainPage",                            //以用户为主体给用户授权界面
	getProductById: API_PREFIX + "/product/getProductById",                      //获得组态页面的内容
	getProductPublishedById: API_PREFIX + "/product/getProductPublishedById",
	
	//device
	getDeviceList: API_PREFIX + "/device/getDeviceList",        //获取设备列表   
	updateDevice:  API_PREFIX + "/device/updateDevice",        //修改设备名称和描述
	deleteDevice:  API_PREFIX + "/device/deleteDevice",        //删除设备
	addDevice:     API_PREFIX + "/device/addDevice",           //新增设备



	//脚本
	getScriptList: API_PREFIX + "/script/getScriptList",           //获得脚本列表
	updateScript: API_PREFIX + "/script/updateScript",            //修改脚本
	deleteScript: API_PREFIX + "/script/deleteScript",             //删除脚本
	publishScript:API_PREFIX + "/script/publishScript",            //发布脚本
	addScript:API_PREFIX + "/script/addScript",                    //新增脚本
	getScriptById:API_PREFIX + "/script/getScriptById",                //通过id获取脚本
	executeEventScript: API_PREFIX + "/script/executeEventScript",   //执行脚本
	executeSampleEventScript: API_PREFIX + "/script/executeSampleEventScript",   //执行脚本
	//变量
	
	getVariableList:API_PREFIX + "/variable/getVariableList",           //获取变量列表
	getSysVariableList:API_PREFIX + "/variable/getSysVariableList",     //获取系统变量列表
	getVariableById:API_PREFIX + "/variable/getVariableById",       //根据id获取变量
	setVariableValue:API_PREFIX + "/variable/setVariableValue",     //根据id改变变量的值
	setSampleVariableValue:API_PREFIX + "/variable/setSampleVariableValue",     //根据id改变变量的值
	getVariableAlertList: API_PREFIX + "/variable/getVariableAlertList",
	getVariableHisValueList: API_PREFIX + "/variable/getVariableHisValueList",
	updateVariable: API_PREFIX + "/variable/updateVariable",      //修改变量的各个信息
	addVariable: API_PREFIX + "/variable/addVariable",        //新增变量
	getAddStatus:API_PREFIX + "/variable/getAddStatus",     //判断是否可以新增
	
	// 用户相关
	getPublicCommentList: API_PREFIX + '/interaction/getPublicCommentList',  //公共消息列表
	addPublicComment: API_PREFIX + '/interaction/addPublicComment',  //公共消息列表
	getDiscussByUserId: API_PREFIX + '/interaction/getDiscussByUserId',  //私有消息列表
	AddPrivateComment: API_PREFIX + '/interaction/AddPrivateComment',  //发布私有消息
	userLogin: API_PREFIX + '/user/UserLoginBYPassword',               //账号密码登录
	userRegister: API_PREFIX + '/user/userRegister',                   //注册
	resetPassword: API_PREFIX + '/user/resetPassword',                 //重置密码
	getUserInfo: API_PREFIX + "/user/getUserInfo",
	getUserInfoSimple: API_PREFIX + "/user/getUserInfoSimple",
	resetPayPassword: API_PREFIX + '/user/resetPayPassword',
	getPromoteMoneyByUserId: API_PREFIX + '/user/getPromoteMoneyByUserId',
	userLogout: API_PREFIX + '/user/userLogout',
	addUserUploadImg: API_PREFIX + "/company/addUserUploadImg", //增加自定义图库图片
	
	// 验证码
	testIfNeedImgVerifyCodePassword:  API_PREFIX + '/message/testIfNeedImgVerifyCode_password',
	testIfNeedImgVerifyCodeSend:  API_PREFIX + '/message/testIfNeedImgVerifyCode_send',
	sendCode:  API_PREFIX + '/message/sendCode',      //发送验证码
	
	// wechat
	addScanLoginRecord: API_PREFIX + '/Wx/addScanLoginRecord',   //获取登录的时候的扫描的二维码
	wxLoginByToken: API_PREFIX + '/Wx/wxLoginByToken',
	UserLoginBYCode: API_PREFIX + '/Wx/UserLoginBYCode',
	getWxConfig: API_PREFIX + '/Wx/getWxConfig',
	getScanLoginState: API_PREFIX + '/Wx/getScanLoginState',
	setScanLoginCode: API_PREFIX + '/Wx/setScanLoginCode',
	
	// User
	getAllUser: API_PREFIX + "/user/getAllUser",
	getLoginUserInfo: API_PREFIX + "/user/getLoginUserInfo",
	updateUserInfo: API_PREFIX + "/user/updateUserInfo",
	
	getReceivedApplyListOfCompany: API_PREFIX + "/company/getReceivedApplyListOfCompany",
	setApplyResult: API_PREFIX + "/company/setApplyResult",
	getSentApplyListOfCompany: API_PREFIX + "/company/getSentApplyListOfCompany",
	companyRegister: API_PREFIX + "/company/companyRegister",
	companyDissolution: API_PREFIX + "/company/companyDissolution",

	
	// Project
	getFirstProjectOfLeader: API_PREFIX + "/project/getFirstProjectOfLeader",
	getSecondProjectOfLeader: API_PREFIX + "/project/getSecondProjectOfLeader",
	addDeveloperForProject: API_PREFIX + "/project/addDeveloperForProject",
	getAllDeveloperOfProject: API_PREFIX + "/project/getAllDeveloperOfProject",
	removeDeveloperFromProject: API_PREFIX + "/project/removeDeveloperFromProject",
	addSubProjectForProject: API_PREFIX + "/project/addSubProjectForProject",
	getSecondProjectOfProject: API_PREFIX + "/project/getSecondProjectOfProject",
	removeProjectFromProject: API_PREFIX + "/project/removeProjectFromProject",
	getAllProjectOfDeveloper: API_PREFIX + "/project/getAllProjectOfDeveloper",
	getAllProjectAccordingToPermission: API_PREFIX +"/project/getAllProjectAccordingToPermission", //获取某用户可读或可交互的所有项目
	removeProjectPermissionOfUser: API_PREFIX +"/project/removeProjectPermissionOfUser",//移除用户对项目的permission权限
	
	
	// Product
	updateMainPage: API_PREFIX + "/product/updateMainPage",
	getPageByType: API_PREFIX + "/product/getPageByType",
	getReleasedPage: API_PREFIX + "/product/getReleasedPage",
	getPageById: API_PREFIX + "/product/getPageById",
	updatePage: API_PREFIX + "/product/updatePage",
	submitCheck: API_PREFIX + "/product/submitCheck",
	checkPage: API_PREFIX + "/product/checkPage",
	removePage: API_PREFIX + "/product/removePage",
	getALLReleasedPage: API_PREFIX + "/product/getALLReleasedPage",
	developPage: API_PREFIX + "/product/developPage",
	getMainPageList: API_PREFIX + "/product/getMainPageList",//获取起始页
	getFreeVarNumAndCompanyIdByProductId: API_PREFIX +"/product/getFreeVarNumAndCompanyIdByProductId",
	
	
	getProductTemplateById: API_PREFIX +"/product/getProductTemplateById", //根据模板id获取模板信息
	//manage
	getAllCompanyUnderCheck: API_PREFIX + "/manager/getAllCompanyUnderCheck",
	getAllCompanyByCondition: API_PREFIX + "/manager/getAllCompanyByCondition",

	// 支付
	alipay: API_PREFIX + '/AliPay/pay',
	getWxQRCode: API_PREFIX + '/wxPay/getQRCode',
	wxGetOrderStatus: API_PREFIX + '/wxPay/getOrderStatus',
	balancePay: API_PREFIX + '/finance/payByUserAccount',
	wXOrderStatus: API_PREFIX + '/wxPay/getOrderStatus',


	//plc程序
	getPLCList: API_PREFIX + "/plc/getPLCList",           	//获得plc程序列表
	updatePLC: API_PREFIX + "/plc/updatePLC",            	//修改plc程序
	deletePLC: API_PREFIX + "/plc/deletePLC",             	//删除plc程序
	publishPLC:API_PREFIX + "/plc/publishPLC",            	//发布plc程序
	addPLC:API_PREFIX + "/plc/addPLC",                    	//新增plc程序
	getPLCById:API_PREFIX + "/plc/getPLCById",              //通过id获取程序
	combilePLC: API_PREFIX + "/plc/combilePLC",   			//编译程序
	getpublishList: API_PREFIX + "/plc/getpublishList",   	//根据plc程序id查询设备列表
	
	// 文件上传
	fileUpload: API_PREFIX + "/file/fileUpload",
}
export default API


